import React, { useState } from 'react'
import ClickAwayListener from '@mui/material/ClickAwayListener'

import NotificationsPopup from './NotificationsPopup'
import ToolBarLink from '../ToolBarLink'
import NotificationsContent from './NotificationsContent'

import notificationIcon from '../../../../assets/icon/notification-icon.svg'

const Notifications = () => {
  const [isNotificationsPopupOpen, setIsNotificationsPopupOpen] = useState(false)

  const handleNotificationsPopupToggle = () => {
    setIsNotificationsPopupOpen((prevState) => !prevState)
  }

  const handleNotificationsPopupClose = () => {
    setIsNotificationsPopupOpen(false)
  }

  return (
    <ClickAwayListener onClickAway={handleNotificationsPopupClose}>
      <div>
        <NotificationsPopup
          title={<NotificationsContent />}
          open={isNotificationsPopupOpen}
          onClose={handleNotificationsPopupClose}
        >
          <div>
            <ToolBarLink
              as="button"
              icon={notificationIcon}
              onClick={handleNotificationsPopupToggle}
              label="Notifications"
            />
          </div>
        </NotificationsPopup>
      </div>
    </ClickAwayListener>
  )
}

export default Notifications
